import { getMomentDate, getLocaleFullName } from './../utils/commonUtils';
import Define from '../constants/Define';
import { PAGINATION } from '../constants/Define';
import moment from 'moment'

export default class Order {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id;
        this.orderCode = data.orderCode || undefined;
        this.setFullName(data);
        this.firstname = data.firstname || undefined;
        this.lastname = data.lastname || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.email = data.email || undefined;
        this.customerLoginInfo = data.customerLoginInfo || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.subTotal = data.subTotal || 0;
        this.totalOriginalAmount = data.totalOriginalAmount || 0;
        this.exchangeCash = data.exchangeCash || 0;
        this.subTotalBeforePromotion = this.totalOriginalAmount || (data.totalAmount || 0) + this.exchangeCash - (data.totalSurcharge || 0) - (data.totalChangeRateCode || 0) + (data.couponValue || 0) || 0;
        this.surcharge = data.surcharge || 0;
        this.status = data.status || 3;
        this.quickTaskStatus = data.quickTaskStatus || 0;
        this.paymentStatus = data.paymentStatus || 0
        this.couponCode = data.couponCode || undefined;
        this.couponValue = data.couponValue || 0;
        this.promotionBankCode = data.promotionBankCode || '';
        this.promotionBankValue = data.promotionBankValue || '';
        this.setItemTypes(data);
        this.paymentType = data.paymentType || undefined;
        this.paymentMethod = data.paymentMethod || undefined;
        this.transactionId = data.transactionId || undefined;
        this.note = data.note || undefined;
        this.setOrderInvoice(data);
        this.setEmailHistories(data);
        this.totalSurcharge = data.totalSurcharge || 0;
        this.totalChangeRateCode = data.totalChangeRateCode || 0;
        this.totalAmount = data.totalAmount || 0;
        this.totalPayment = data.totalPayment || 0;
        this.totalPaymentDiscount = data.totalPaymentDiscount || 0;
        this.saleChannel = data.saleChannel || undefined;
        this.installmentFee = data.installmentFee || undefined;
        this.creditPoint = data.creditPoint || 0;
        this.installmentLimit = data.installmentLimit || undefined;
        this.setErrors(data);
        this.isUpdateOrderStatus = data.isUpdateOrderStatus || false;
        this.channel = data.channel || undefined;
        this.memberShipCode = data.memberShipCode || undefined;
        this.isRecommitHotelBundle = data.isRecommitHotelBundle || false;
        this.canRetryCiapsBooking = data.canRetryCiapsBooking || false;
        this.bookerEmail = data?.bookerEmail || '';
        this.isLoginedUser = Boolean(data.bookerEmail);
        this.soStatus = data?.soStatus || '';
        this.oiStatus = data?.oiStatus || '';
        this.vgId = data.vgId || '';
        this.memberShipFirstname = data.memberShipFirstname || '';
        this.memberShipLastname = data.memberShipLastname ||'';
        this.memberShipCardNumber = data.memberShipCardNumber || '';
        this.orderProfiles = OrderProfiles.parseDataFromResponse(data?.orderProfiles || []);
        this.fxChargeFailNum = data.fxChargeFailNum || 0;
        this.affSource = data.affiliateSource || 'original';
        this.affSID = data.affiliateSId || '';
        this.affStatus = { orderId: data.id, status: data.affStatus, paymentStatus: data.paymentStatus };
        this.languageCode = data.languageCode || 'vi-VN';
        this.currencyCode = data.currencyCode || 'VND';
        this.childOrderCodes = data.childOrderCodes || [];
        this.parentOrderCode = data.parentOrderCode || {};
        this.accountantStatus = data.accountantStatus;
        this.linkCrossSale = data.linkCrossSale || undefined;
    }

    setItemTypes(data = {}) {
        this.itemTypes = data.itemTypes || [];
    }

    setFullName(data = {}) {
        this.fullname = data.fullname || getLocaleFullName(data.firstname, data.lastname)
    }

    setOrderInvoice(data = {}) {
        this.invoice = data.invoice && new OrderInvoice(data.invoice);
    }

    setEmailHistories(data = {}) {
        this.emailHistories = (data.emailHistories || []).map(item => new EmailHistory(item))
    }

    setErrors(data = {}) {
        if(!data.errors){
            this.errors = []
        }
        try {
            this.errors = JSON.parse(data.errors).map(item => new OrderError(item));
        } catch (e) {
            this.errors = [];
        }
    }

    export() {
        return {
            id: this.id,
            status: this.status,
            paymentStatus: this.paymentStatus,
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            phoneNumber: this.phoneNumber,
            note: this.note,
            saleChannel: this.saleChannel,
            paymentType: this.paymentType,
            transactionId: this.transactionId
        }
    }

}

export class OrderItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.setFlight(data);
        this.setHotel(data);
        this.setLinkCrossSales(data);
        this.setTour(data);
        this.setVoucher(data);
        this.setVinWonder(data);
        this.setVinWonderTour(data);
        this.setHomestay(data);
        this.setFnb(data);
    }

    setFlight(data = {}) {
        this.flight = data.flight ? {
            orderId: data.flight.orderId || undefined,
            productVariantId: data.flight.productVariantId || undefined,
            quantity: data.flight.quantity || 0,
        } : undefined;
    }

    setHotel(data) {
        this.hotels = (data.hotels || []).map(item => (new OrderHotelItem(item)));
    }

    setHomestay(data) {
        this.homestays = (data.homestays || []).map(item => (new OrderHomestayItem(item)));
    }

    setLinkCrossSales (data) {
        this.linkCrossSales = data.linkCrossSales ? (data.linkCrossSales || []).map(item => (new OrderTourItem(item))) : [];
    }

    setTour(data) {
        this.tours = data.tours ? (data.tours || []).map(item => (new OrderTourItem(item))) : [];
    }

    setVinWonder(data = {}) {
        this.vinWonders = data.vinWonders ? (data.vinWonders || []).map(item => (new OrderVinWonderItem(item))) : [];
    }

    setSurcharge(data) {
        this.surcharges = data.surcharges ? (data.surcharges || []).map(item => (new OrderSurchargeItem(item))) : [];
    }

    setVoucher(data) {
        this.vouchers = data.vouchers ? (data.vouchers || []).map(item => (new OrderVoucherItem(item))) : [];
    }

    setVinWonderTour(data) {
        this.vinWonderTour = data.vinWonderTour ? (data.vinWonderTour || []).map(item => (new OrderTourItem(item))) : [];
    }

    setFnb(data) {
        this.fnbs = data.fnbItems ? (data.fnbItems || []).map(item => (new OrderFnbItem(item))) : [];
    }

}

export class OrderHotelItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.productVariantId = item.productVariantId;
        this.setDetail(item.surcharges || {})
    }

    setDetail(data = {}) {
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.surcharges || []).map(item => new OrderSurchargeItem(item))
        }
    }
}

export class OrderHomestayItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.productVariantId = item.productVariantId;
        this.setDetail(item.surcharges || {})
    }

    setDetail(data = {}) {
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.surcharges || []).map(item => new OrderSurchargeItem(item))
        }
    }
}

export class OrderVoucherItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.orderId = item.orderId || undefined;
        this.productVariantId = item.productVariantId || undefined;
        this.groupName = item.groupName || undefined;
        this.rateCode = item.rateCode || undefined;
        this.voucherType = item.voucherType || Define.GENERAL.VOUCHER_TYPE.GIFT;
        this.discountValue = item.discountValue || 1;
        this.quantity = item.quantity || 0;
        this.originalPrice = item.originalPrice || 0;
        this.salePrice = item.salePrice || 0;
        this.checkCode = item.checkCode || undefined;
        this.status = item.status || undefined;
        this.serialNumber = item.serialNumber || undefined;
        this.operaBookingCode = item.operaBookingCode;
        this.checkInDate = item.checkInDate && getMomentDate(item.checkInDate);
        this.checkOutDate = item.checkOutDate && getMomentDate(item.checkOutDate);
        this.propertyOfStay = item.propertyOfStay || undefined;
        this.property = item.property || undefined;
        this.checkedDate = item.checkedDate ? getMomentDate(item.checkedDate) : undefined;
        this.itemVariantId = item.itemVariantId || undefined;
        this.setDetail(item.surcharges || {});
        this.isLocked = item.isLocked || false;
        this.rateCodeId = item.rateCodeId || undefined;
    }

    setDetail(data = {}) {
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.surcharges || []).map(item => new OrderSurchargeItem(item))
        }
    }
}

export class OrderTourItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.orderId = item.orderId || undefined;
        this.productVariantId = item.productVariantId || undefined;
        this.itemVariantId = item.itemVariantId || undefined;
        this.tourName = item.tourName || undefined;
        this.tourCode = item.tourCode || undefined;
        this.departureDate = getMomentDate(item.departureDate);
        this.lengthOfTour = parseFloat(item.lengthOfTour || 0);
        this.originalPrice = item.originalPrice || 0;
        this.salePrice = item.salePrice || 0;
        this.serialNumber = item.serialNumber || undefined;
        this.checkInDate = item?.checkinDate ? getMomentDate(item.checkinDate, undefined, false) : getMomentDate(item.departureDate, undefined, false);
        this.checkOutDate = item?.checkoutDate
            ? getMomentDate(item.checkoutDate, undefined, false)
            : this.checkInDate && moment(this.checkInDate).add((Math.floor(this.lengthOfTour)) - 1, 'days');
        this.effectiveEndDate = getMomentDate(item.effectiveEndDate);
        this.effectiveStartDate = getMomentDate(item.effectiveStartDate);
        this.status = item.status || undefined;
        this.operaBooking = item.operaBooking || undefined;
        this.note = item.note || undefined;
        this.propertyName = item.propertyName || undefined;
        this.ticketName = item.ticketName || undefined;
        this.ticketType = item.ticketType || undefined;
        this.ticketStatus = item.ticketStatus;
        this.isLocked = item.isLocked || false;
        this.objectType = item.objectType || undefined;
        this.type = item.type || undefined;
        this.property = item.property || undefined;
        this.rateCode = item.rateCode || undefined;
        this.rateCodeId = item.rateCodeId || undefined;
        this.seatNo = item.seatNo || undefined;
        this.properties = item.properties || [];
        this.redeemPropertyId = item.redeemPropertyId || undefined;
        this.redeemProperty = item.redeemProperty || undefined;
        this.confirmNumber = item.confirmNumber || undefined;
        this.refundConfirmed = item.refundConfirmed || 0;
        this.refundWaiting = item.refundWaiting || 0;
        this.objectTypeCombos = item.objectTypeCombos || [];
        this.setDetail(item.surcharges || {});
        this.loyaltyCampaignCode = item.loyaltyCampaignCode || undefined;
        this.loyaltyCommitStatus = item.loyaltyCommitStatus;
        this.loyaltyLinkType = item.loyaltyLinkType || undefined;
        this.loyaltyLinkValue = item.loyaltyLinkValue || undefined;
        this.giftPointCommitStatus = item.giftPointCommitStatus || undefined;
        this.giftPointValue = item.giftPointValue || 0;
        this.sessionInfo = item.sessionInfo || undefined;
        this.comboData = item.comboData || [];
    }

    setDetail(data = {}) {
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.surcharges || []).map(item => new OrderSurchargeItem(item))
        }
    }

    export() {
        return {
            serialNumber: this.serialNumber,
            status: this.status,
            operaBooking: this.operaBooking,
            note: this.note,
        }
    }

}

export class OrderVinWonderBookingItems {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.orderId = item.orderId || undefined;
        this.productVariantId = item.productVariantId || undefined;
        this.vinWonderName = item.vinWonderName || undefined;
        this.vinWonderTicketName = item.vinWonderTicketName || undefined;
        this.serialNumber = item.serialNumber || undefined;
        this.usingDate = getMomentDate(item.usingDate);
        this.sessionInfo = item.sessionInfo || undefined;
        this.siteCode = item.siteCode || undefined;
        this.originalPrice = item.originalPrice || 0;
        this.salePrice = item.salePrice || 0;
        this.quantity = item.quantity || 0;
        this.childOriginalPrice = item.childOriginalPrice || 0;
        this.childSalePrice = item.childSalePrice || 0;
        this.childQuantity = item.childQuantity || 0;
        this.seniorOriginalPrice = item.seniorOriginalPrice || 0;
        this.seniorSalePrice = item.seniorSalePrice || 0;
        this.seniorQuantity = item.seniorQuantity || 0;
        this.ticketType = item.ticketType || undefined;
        this.salePrice = item.salePrice || 0;
        this.status = item.status || 0;
        this.statusText = item.statusText || undefined;
        this.itemVariantId = item.itemVariantId || undefined;

        this.setDetail(item.surcharges || {});
    }

    setDetail(data = {}) {
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.surcharges || []).map(item => new OrderSurchargeItem(item))
        }
    }
}

export class OrderVinWonderBookingCustomer {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.fullName = item.fullName || undefined;
        this.dateOfBirth = item.dateOfBirth || undefined;
        this.placeOfBirth = item.placeOfBirth || undefined;
        this.email = item.email || undefined;
        this.identityType = item.identityType || 1;
        this.identityTypeName = item.identityTypeName || undefined;
        this.identityDetail = item.identityDetail || undefined;
        this.nationalityID = item.nationalityID || 1;
        this.nationalityName = item.nationalityName || 1;
        this.phone = item.phone || undefined;
        this.sex = item.sex || 0;
        this.zonePickupId = item.zonePickupId || undefined;
        this.zoneReleaseId = item.zoneReleaseId || undefined;
        this.zonePickupName = item.zonePickupName || undefined;
        this.zoneReleaseName = item.zoneReleaseName || undefined;
    }
}

export class OrderVinWonderItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.orderId = item.orderId || undefined;
        this.productVariantId = item.productVariantId || undefined;
        this.setBookingItems(item);
        this.setBookingCustomer(item);
    }

    setBookingItems(data) {
        this.bookingItems = data.bookingItems ? (data.bookingItems || []).map(item => (new OrderVinWonderBookingItems(item))) : [];
    }

    setBookingCustomer(data) {
        this.bookingCustomers = data.bookingCustomers ? (data.bookingCustomers || []).map(item => (new OrderVinWonderBookingCustomer(item))) : [];
    }

}

export class OrderSurchargeItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.id = item.id;
        this.orderId = item.orderId || undefined;
        this.rateCodes = item.rateCodes || [];
        this.ftCode = item.ftCode || undefined;
        this.amount = item.amount || 0;
        this.isDeleted = item.isDeleted || false;
        this.note = item.note || undefined;
        this.name = item.name || undefined;
        this.surchargeType = item.surchargeType || undefined;
        this.paymentType = item.paymentType || undefined;
        this.paymentDate = getMomentDate(item.paymentDate);
        this.operaBookingCode = item.operaBookingCode || undefined;
        this.transactionId = item.transactionId || undefined;
        this.itemVariantId = item.itemVariantId || undefined;
    }

    export() {
        return {
            id: this.id,
            orderId: this.orderId,
            name: this.name,
            surchargeType: this.surchargeType,
            paymentType: this.paymentType,
            operaBookingCode: this.operaBookingCode,
            transactionId: this.transactionId,
            amount: this.amount,
            note: this.note,
            paymentDate: this.paymentDate,
            itemVariantId: this.itemVariantId
        }
    }
}
export class SurchargeItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.ftCode = item.ftCode || undefined;
        this.amount = item.amount || 0;
        this.itemVariantId = item.itemVariantId || undefined;
        this.pmsTransactionCode = item.pmsTransactionCode || undefined
        this.surchargeId = item.surchargeId || undefined
        this.isTCodeValid = item.isTCodeValid || false;
    }

    export() {
        return {
            ftCode: this.ftCode,
            amount: this.amount,
            itemVariantId: this.itemVariantId,
            pmsTransactionCode: this.pmsTransactionCode,
            surchargeId: this.surchargeId,
            isTCodeValid: this.isTCodeValid,
        }
    }
}

export class OrderBundleSurchargeItem {
  constructor(data = {}) {
      this.setData(data)
  }

  setData(item) {
    this.amount = item.amount || 0;
    this.surchargeType = item.surchargeType || undefined;
    this.isDeleted = item.isDeleted || false;
    this.createdDate = item.createdDate;
    this.ftCode = item.ftCode || undefined;
    this.note = item.note || undefined;
    this.createdBy = item.createdBy || "";
    this.orderCode = item.orderCode || "";
    this.orderItemType = item.orderItemType || 0;
    this.transactionName = item.transactionName || "";
    this.transactionCode = item.transactionCode || "";
    this.id = item.id;
    this.orderId = item.orderId || undefined;
    this.rateCodes = item.rateCodes || [];
    this.name = item.name || undefined;
    this.paymentType = item.paymentType || undefined;
    this.paymentDate = getMomentDate(item.paymentDate);
    this.operaBookingCode = item.operaBookingCode || undefined;
    this.transactionId = item.transactionId || undefined;
    this.itemVariantId = item.itemVariantId || undefined;
}

export() {
    return {
      amount: this.amount,
      surchargeType: this.surchargeType,
      isDeleted: this.isDeleted,
      createdDate: this.createdDate,
      ftCode: this.ftCode,
      note: this.note,
      createdBy: this.createdBy,
      orderCode: this.orderCode,
      orderItemType: this.orderItemType,
      transactionName: this.transactionName,
      transactionCode: this.transactionCode,
      id: this.id,
      orderId: this.orderId,
      rateCodes: this.rateCodes,
      name: this.name,
      paymentType: this.paymentType,
      paymentDate: this.paymentDate,
      operaBookingCode: this.operaBookingCode,
      transactionId: this.transactionId,
      itemVariantId: this.itemVariantId
    }
}
}

export class VoucherDetailItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.checkCode = data.checkCode || undefined;
        this.status = data.status || 4;
    }

}

export class OrderInvoice {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id || undefined;
        this.orderId = data.orderId || undefined;
        this.fullName = data.fullName || undefined;
        this.companyName = data.companyName || undefined;
        this.address = data.address || undefined;
        this.taxCode = data.taxCode || undefined;
    }

    export() {
        return {
            id: this.id,
            orderId: this.orderId,
            fullName: this.fullName,
            companyName: this.companyName,
            address: this.address,
            taxCode: this.taxCode,
        }
    }
}

export class EmailHistory {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id || undefined;
        this.senderId = data.senderId || undefined;
        this.mailTo = data.mailTo || undefined;
        this.title = data.title || undefined;
        this.createdTime = getMomentDate(data.createdTime);
    }

    export() {
        return {
            id: this.id,
            senderId: this.senderId,
            mailTo: this.mailTo,
            title: this.title,
            createdTime: this.createdTime && this.createdTime.toISOString(),
        }
    }
}

export class OrderItemStatus {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id || undefined
        this.orderId = data.orderId || undefined;
        this.itemVariantId = data.itemVariantId || undefined
        this.status = data.status || undefined;
        this.orderStatus = data.orderStatus || undefined;
        this.orderItemType = data.orderItemType || undefined;
        this.typeSKU = [1, 2, 5];
        this.operaBooking = data.operaBooking || undefined;
        this.note = data.note || undefined;
        this.isReturn = data.isReturn || false;
        this.refundProductIds = data.refundProductIds || undefined;
        this.RefundType = data.RefundType || undefined;
        this.RefundDetail = data.RefundDetail || undefined;
    }

    export() {
        return {
            orderId: this.orderId,
            itemVariantId: this.typeSKU.includes(this.orderItemType) ? this.itemVariantId : this.id,
            status: this.orderItemType !== 4 ? this.status : this.orderStatus,
            orderItemType: this.orderItemType,
            operaBooking: this.operaBooking,
            note: this.note,
            isReturn: this.orderItemType === 3 ? this.isReturn : undefined,
            refundProductIds: this.refundProductIds || undefined,
            RefundType: this.RefundType || undefined,
            RefundDetail: this.RefundDetail || undefined
        }
    }
}

export class OrderItemLock {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id || undefined
        this.orderId = data.orderId || undefined;
        this.itemVariantId = data.itemVariantId || undefined
        this.orderItemType = data.orderItemType || undefined;
        this.typeSKU = [1, 2, 5];
        this.isLocked = data.isLocked || false;
    }

    export() {
        return {
            orderId: this.orderId,
            itemVariantId: this.typeSKU.includes(this.orderItemType) ? this.itemVariantId : this.id,
            orderItemType: this.orderItemType,
            isLocked: !this.isLocked
        }
    }
}

export class OrderError {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.code = data.code || data.Code || undefined
        this.message = data.message || data.Message || undefined;
    }

}

export class OrderUpdateStatus {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id || undefined;
        this.status = data.status || undefined;
    }

    export() {
        return {
            id: this.id,
            status: this.status,
        }
    }
}


export class RedeemTourOrder {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.orderId = data.orderId || undefined;
        this.itemVariantId = data.itemVariantId || undefined;
        this.itineraryNumber = data.itineraryNumber || undefined;
        this.voucherCode = data.voucherCode || undefined;
        this.dataConfirm = data.data || data.dataConfirm || undefined;
        this.note = data.note || undefined;
        this.confirmSelected = data.confirmSelected || undefined;
        this.propertyID = data.propertyID || undefined;
        this.transportations = data.transportations || [];
        this.redeemPropertyId = data.redeemPropertyId || undefined;
    }

    exportCheck() {
        return {
            orderId: this.orderId,
            itemVariantId: this.itemVariantId,
            itineraryNumber: this.itineraryNumber,
            voucherCode: this.voucherCode
        }
    }

    exportRedeem(index = -1) {
        return {
            orderId: this.orderId,
            itemVariantId: this.itemVariantId,
            itineraryNumber: this.itineraryNumber,
            voucherCode: this.voucherCode,
            note: this.note,
            reservationID: index > -1 ? this.dataConfirm.reservationInfos[index].reservationID : undefined,
            confirmationNumber: index > -1 ? this.dataConfirm.reservationInfos[index].confirmationNumber : undefined,
            // profiles: this.dataConfirm[index].profiles
            transportations: this.transportations,
            redeemPropertyId: this.redeemPropertyId,
            isIgnoreFixcharge: this.isIgnoreFixcharge || false
        }
    }
}

export class SurchargeTour {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id || undefined;
        this.orderId = data.orderId || undefined;
        this.itemVariantId = data.itemVariantId || undefined;
        this.note = data.note || undefined;
        this.rateCodes = data.rateCodes || [];
        this.ftCode = data.ftCode || undefined;
        // this.surchargeType = '1500'
        this.listType = 'tours'
        this.name = 'tours'
        this.pmsTransactionCode = data.pmsTransactionCode || undefined
    }

    export() {
        return {
            id: this.id,
            orderId: this.orderId,
            itemVariantId: this.itemVariantId,
            note: this.note,
            rateCodes: this.rateCodes,
            ftCode: this.ftCode,
            // surchargeType: this.surchargeType,
            listType: this.listType,
            pmsTransactionCode: this.pmsTransactionCode
        }
    }
}

export class Customer {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.dateOfBirth = data.dateOfBirth || undefined;
        this.email = data.email || undefined;
        this.fullName = data.fullName || undefined;
        this.identityDetail = data.identityDetail || undefined;
        this.identityType = data.identityType || undefined;
        this.nationalityID = data.nationalityID || undefined;
        this.phone = data.phone || undefined;
        this.placeOfBirth = data.placeOfBirth || undefined;
        this.sex = data.sex;
    }
}

export class SmsHistory {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id;
        this.orderId = data.orderId;
        this.shortCode = data.shortCode;
        this.content = data.content;
        this.receivers = data.receivers;
        this.status = data.status;
        this.createdDate = data.createdDate;
        this.createdBy = data.createdBy;
    }
}

export class OrderProfiles {
    constructor(data = {}) {
        this.setData(data);
    }
    setData(data) {
        this.id = data.id || '';
        this.orderId = data.orderId || '';
        this.firstName = data.firstName || '';
        this.lastName = data.lastName || '';
        this.phoneNumber = data.phoneNumber || '';
        this.nationality = data.nationality || '';
        this.email = data.email || '';
        this.vgId = data.vgId || '';
        this.memberShipCode = data.memberShipCode || '';
        this.createdDate = data.createdDate || '';
        this.createdBy = data.createdBy || '';
    }
    static parseDataFromResponse(response = []) {
        if (response.length > 0) {
            return response.map(e => new OrderProfiles(e))
        }
        return []
    }
    export() {
        return {
            id: this.id,
            phoneNumber: this.phoneNumber,
            nationality: this.nationality,
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName
        }
    }
}

export class FixChargeItem {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.id = data.id;
        this.fixchargeCode = data.fixchargeCode;
        this.itiNumber = data.itiNumber;
        this.reservationCode = data.reservationCode;
        this.amount = data.amount;
        this.fixchargeStatus = data.fixchargeStatus;
        this.action = data.action;
        this.createdDate = data.createdDate;
    }
}
export class PointHistory {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.id = data.id;
        this.orderId = data.orderId;
        this.orderCode = data.orderCode;
        this.vinClubBranchId = data.vinClubBranchId;
        this.amount = data.amount;
        this.sessionId = data.sessionId;
        this.status = data.status;
        this.refundStatus = data.refundStatus;
        this.createdDate = data.createdDate;
        this.vgId = data.vgId;
        this.type = data.type;
        this.orderRefundStatus = data.orderRefundStatus;
        this.refundBy = data.refundBy;
        this.refundAt = data.refundAt;
    }
}

export class OrderFnbItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(item) {
        this.orderId = item.orderId || undefined;
        this.productVariantId = item.productVariantId || undefined;
        this.setDetail(item);
        this.items = item.items ? (item.items || []).map(i => new OrderFnbDish(i)) : [];
    }

    setDetail(data = {}) {
        this.detail = new OrderFnbItemDetail(data);
    }
}

export class OrderFnbItemDetail {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.restaurantName = data.outletName || data.restaurantName || '';
        this.bookingCode = data.fnbOrderCode || data.bookingCode || '';
        this.status = data.fnbOrderStatus || data.status || '';
        this.pickupTime = data.pickupTimeStart ? `${moment(data.pickupTimeStart).format('HH:mm')} - ${moment(data.pickupTimeEnd).format('HH:mm')}` : null;
        this.orderTime = data.orderTime ? getMomentDate(data.orderTime) : null;
        this.totalAmount = data.totalAmount || 0;
        this.pickupMode = data.fnbOrderType || data.pickupMode || ''; 
        this.note = data.note || '';
    }
}

export class OrderFnbDish {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.name = data.productName || data.name || '';
        this.quantity = data.quantity || 0;
        this.price = data.salePrice || data.price || 0;
        this.discount = (data.originalPrice > data.salePrice) ? (data.originalPrice - data.salePrice) : (data.discount || 0);
        this.total = (data.salePrice * data.quantity) || data.total || 0;
        this.note = data.note || '';
    }
}
